import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import { Modal } from "antd";
import dayjs from "dayjs";
import React from "react";
import { Delivery } from "../../models/Delivery";

interface Props {
    deliveryCopy: Delivery;
    updateDeliveryCopy: (delivery: Delivery) => void;
    saveDelivery: (delivery: Delivery) => Promise<any>;
    visible: boolean;
    hideModal: () => void;
}

const ConfirmETA: React.FC<Props> = (props) => {
    const confirmETA = () => {
        props.saveDelivery(props.deliveryCopy).then(() => {
            props.hideModal();
        });
    };

    const addTime = (value: number) => {
        const newDeliveryCopy = Object.create(props.deliveryCopy) as Delivery;
        newDeliveryCopy.eta = dayjs(props.deliveryCopy.eta)?.add(value, "minute");
        props.updateDeliveryCopy(newDeliveryCopy);
    };

    const subtractTime = (value: number) => {
        const newDeliveryCopy = Object.create(props.deliveryCopy) as Delivery;
        newDeliveryCopy.eta = dayjs(props.deliveryCopy.eta)?.subtract(value, "minute");

        props.updateDeliveryCopy(newDeliveryCopy);
    };

    if (!props.deliveryCopy.eta) {
        return null;
    }

    return (
        <Modal
            open={props.visible}
            destroyOnHidden={true}
            onOk={confirmETA}
            onCancel={props.hideModal}
            className="text-center"
        >
            <div className="text-center items-center">
                <div className="sectionCallout">Confirm Setting ETA For: </div>
                <div className="text-7xl font-medium uppercasee font-[Oswald] inline-flex items-center text-center text-stone-700">
                    <div>{props.deliveryCopy.eta.format("hh")}</div>
                    <div>:</div>
                    <div>{props.deliveryCopy.eta.format("mm")}</div>
                    <div>{props.deliveryCopy.eta.format("A")}</div>
                    <div className="flex flex-col justify-center items-center ml-2 h-full ">
                        <ButtonGroup
                            variant="contained"
                            disableElevation
                            orientation="vertical"
                            aria-label="vertical outlined button group"
                        >
                            <Button onClick={() => addTime(1)} sx={{ color: "white", padding: "0.5em" }}>
                                <FontAwesomeIcon icon={faArrowUp} />
                            </Button>
                            <Button onClick={() => subtractTime(1)} sx={{ color: "white", padding: "0.5em" }}>
                                <FontAwesomeIcon icon={faArrowDown} />
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmETA;
